module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1"
  }, [_c('p', {
    staticClass: "ORIM-Chapter-Title-Page-Break--Body-",
    attrs: {
      "id": "_idParaDest-5"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor004"
    }
  }), _vm._v("CHAPTER II")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Ten minutes later she was putting to Miss Wanostrocht, firmly if without ferocity, the question:")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Look here, Head, what did that woman say to you. I don’t like her; I don’t approve of her and I didn’t really listen to her. But I want to hear!”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Miss Wanostrocht, who had been taking her thin, black cloth coat from its peg behind the highly varnished pitch-pine door of her own private cell, flushed, hung up her garment again and turned from the door. She stood, thin, a little rigid, a little flushed, faded and a little as it were at bay.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“You must remember,” she began, “that I am a schoolmistress.” She pressed, with a gesture she constantly had, the noticeably golden plait of her dun-coloured hair with the palm of her thin left hand. None of the gentlewomen of that school had had quite enough to eat—for years now. “It’s,” she continued, “an instinct to accept any means of knowledge. I like you so much, Valentine—if in private you’ll let me call you that. And it seemed to me that if you were in …”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“In what?” Valentine asked, “Danger? … Trouble?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“You understand,” Miss Wanostrocht replied, “That … person seemed as anxious to communicate to me facts about yourself as to give you—that was her ostensible reason for ringing you up—news About a … another person. With whom you once had … relations. And who has reappeared.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Ah,” Valentine heard herself exclaim. “He has reappeared, has he? I gathered as much.” She was glad to be able to keep herself under control to that extent.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Perhaps she did not have to trouble. She could not say that she felt changed from what she had been—just before ten minutes ago, by the reappearance of a man she hoped she had put out of her mind. A man who had “insulted” her. In one way or the other he had insulted her!")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("But probably all her circumstances had changed. Before Edith Ethel had uttered her impossible sentence in that instrument her complete prospects had consisted of no more than the family picnic, under fig-trees, beside an unusually blue sea—and the prospect had seemed as near—as near as kiss your finger! Mother in black and purple; mother’s secretary in black without adornments. Brother? Oh, a romantic figure; slight, muscular, in white flannels with a Leghorn hat and—well, why ")]), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("not")]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }, [_vm._v(" be romantic over one")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("’s brother—with a broad scarlet sash. One foot on shore and one … in a light skiff that gently bobbed in the lapping tide. Nice boy; nice little brother. Lately employed nautically, so up to managing a light skiff. They were going to-morrow … but why not that very afternoon by the 4.20?")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Blockquote--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“They’d got the ships, they’d got the men,"), _c('br'), _vm._v("They’d got the money too!”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Thank goodness they’d got the money!")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("The ships, Charing Cross to Vallambrosa, would no doubt run in a fortnight. The men—the porters—would also be released. You can’t travel in any comfort with mother, mother’s secretary and brother—with your whole world and its baggage—without lots of porters…. Talk about rationed butter! What was that to trying to get on without porters?")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Once having begun it her mind went on singing the old eighteen-fiftyish, or seventy-ish, martial, British, anti-Russian patriotic song that one of her little friends had unearthed lately—to prove the historic ferocity of his countrymen:")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Blockquote--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“We’ve fought the Bear before,"), _c('br'), _vm._v("And so we will again!"), _c('br'), _vm._v("The Russians shall not have Constantino …”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("She exclaimed suddenly: “")]), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Oh!")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("She had been about to say: “Oh, ")]), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Hell")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("!” but the sudden recollection that the War had been over a quarter of an hour made her leave it at “")]), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Oh!")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("” You would have to drop war-time phraseology! You became again a Young Lady. Peace, too, has its Defence of the Realm Acts. Nevertheless, she has been thinking of the man who had once insulted her as the Bear, whom she would have to fight again! But with warm generosity she said:")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“It’s a shame to call him the Bear!” Nevertheless he was—the man who was said to have “reappeared “—with his problems and all, something devouring…. Overwhelming, with rolling grey shoulders that with their intolerable problems pushed you and your own problems out of the road….")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("She had been thinking all that whilst still in the School Hall, before she had gone to see the Head: immediately after Edith Ethel, Lady Macmaster had uttered the ")]), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("intolerable")]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }, [_vm._v(" sentence.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("She had gone on thinking there for a long time…. Ten minutes!")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("She formulated for herself summarily the first item of a period of nasty worries of a time she flattered herself she had nearly forgotten. Years ago, Edith Ethel, out of a clear sky, had accused her of having had a child by that man. But she hardly thought of him as a man. She thought of him as a ponderous, grey, intellectual mass who now, presumably, was mooning, obviously dotty, since he did not recognise the porter, behind the closed shutters of an empty house in Lincoln’s Inn…. Nothing less, I assure you! She had never been in that house, but she figured him, with cracks of light coming between the shutters, looking back over his shoulder at you in the doorway, grey, super-ursine…. Ready to envelop you in suffocating bothers!")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("She wondered how long it had been since the egregious Edith Ethel had made that assertion … with, naturally, every appearance of indignation for the sake of the man’s Wife with whom, equally naturally, Edith Ethel had “sided.” (Now she was trying to “bring you together again.” … The Wife, presumably, did not go to Edith Ethel’s tea-parties often enough, or was too brilliantly conspicuous when there. Probably the latter!) … How many years ago? Two? Not so much! Eighteen months, then? Surely more! … surely, surely more! … When you thought of Time in those days your mind wavered impotently like eyes tired by reading too small print…. He went out surely in the autumn of … No, it had been the first time he went that he went in the autumn. It was her brother’s friend, Ted, that went in ‘16. Or the other … Malachi. So many goings out and returnings: and goings out and perhaps not returning. Or only in bits: the nose gone … or both eyes. Or—or, Hell! oh, Hell! and she clenched her fists, her nails into her palms—no mind!")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("You’d think it must be that from what Edith Ethel had said. He hadn’t recognised the porter: he was reported to have no furniture. Then … She remembered….")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("She was then—ten minutes before she interviewed Miss Wanostrocht; ten seconds after she had been blown out of the mouth of the telephone—sitting on a varnished pitch-pine bench that had black iron, clamped legs against the plaster wall, non-conformishistically distempered in torpedo-grey; and she had thought all that in ten seconds…. But that had been ")]), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("really")]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }, [_vm._v(" how it had been!")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("The minute Edith Ethel had finished saying the words:")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“The sum would be absolutely ")]), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("crushing")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("….” Valentine had realised that she had been talking about a debt owed by her miserable husband to the one human being she, Valentine, could not bear to think about. It had naturally at the same moment flashed upon her that Edith Ethel had been giving her his news: He was in new troubles: broken down, broken up, broke to the wide…. Anything in the world but broken in…. But broken … And alone…. And calling for her!")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("She could not afford—she could not bear!—to recall even his name or to so much as bring up before her mind, into which, nevertheless, they were continually forcing themselves, his grey-blond face, his clumsy, square, reliable feet; his humpish bulk; his calculatedly wooden expression; his perfectly overwhelming, but authentic omniscience…. His masculinity. His … his Frightfulness!")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Now, through Edith Ethel—you would have thought that even ")]), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("he")]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }, [_vm._v(" would have found someone more appropriate—he was calling to her again to enter into the suffocating web of his imbroglios. Not even Edith Ethel would have dared to speak to her again of him without his having taken the first step….")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("It was unthinkable; it was intolerable; and it had been as if she had been lifted off her feet and deposited on that bench against the wall by the mere sound of the offer…. What was the offer?")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“I thought that you might, if I were the means of bringing you together …” She might … what?")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Intercede with that man, that grey mass not to enforce the pecuniary claim that it had against Sir Vincent Macmaster. No doubt she and … the grey mass! … would then be allowed the Macmaster drawing-room to … to discuss the ethics of the day in! Just like that!")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("She was still breathless; the telephone continued to quack. She wished it would stop but she felt too weak to get up and hang the receiver on its hook. She wished it would stop; it gave her the feeling that a strand of Edith Ethel’s hair, say, was penetrating nauseously to her torpedo grey cloister. Something like that!")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("The grey mass never would enforce its pecuniary claim…. Those people had sponged mercilessly on him for years and years without ever knowing the kind of object upon which they sponged. It made them the more pitiful. For it ")]), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("was")]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }, [_vm._v(" pitiful to clamour to be allowed to become a pimp in order to evade debts that would never be reclaimed….")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Now, in the empty rooms at Lincoln’s Inn—for that was probably what it came to!—that man was a grey ball of mist; a grey bear rolling tenebrously about an empty room with closed shutters. A grey problem! Calling to ")]), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("her")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("!")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("A hell of a lot…. Beg pardon, she meant a remarkably great deal! … to have thought of in ten seconds! Eleven, by now, probably. Later she realised that that was what thought was. In ten minutes after large, impassive arms had carried you away from a telephone and deposited you on a clamped bench against a wall of the peculiar coldness of torpedo-grey distempered plaster, the sort of thing rejoiced in by Great Public (Girls’) Schools … in those ten minutes you found you thought out more than in two years. Or it was not as long ago as that.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Perhaps that was not astonishing. If you had not thought about, say, washable distemper for two years and then thought about it for ten minutes you could think a hell of a lot about it in those ten minutes. Probably all there was to think. Still, of course, washable distemper was not like the poor—always with you. At least it always was in those cloisters, but not spiritually. On the other hand you always ")]), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("were")]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }, [_vm._v(" with yourself!")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("But perhaps you were not always with yourself spiritually; you went on explaining how to breathe without thinking of how the life you were leading was influencing your … What? Immortal soul? Aura? Personality? … Something!")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Well, for two years…. Oh, ")]), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("call")]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }, [_vm._v(" it two years, for goodness")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("’ sake, and get it over! … she must have been in … well, call ")]), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("that")]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }, [_vm._v(" a ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“state of suspended animation” and get that over too! A sort of what they called inhibition. She had been inhibiting—")]), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("pro")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("hibiting—herself from thinking about herself. Well, hadn’t she been right? What had a b—y Pro-German to think about in an embattled, engrossed, clamouring nation: especially when she had not much liked her brother-Pro’s! A solitary state, only to be dissolved by … maroons! In suspension!")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("But … Be conscientious with yourself, my good girl! ")]), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("When that telephone blew you out of its mouth you knew really that for two years you had been avoiding wondering whether you had not been insulted!")]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }, [_vm._v(" Avoiding wondering that. And nothing else! No other qualified thing!")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("She had, of course, been, not in suspension, but in suspense. Because, if he made a sign—”I understand,” Edith Ethel had said, “that you have not been in correspondence” … or had it been “in communication” that she had said? … Well, they hadn’t been either….")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Anyhow, if that grey Problem, that ravelled ball of grey knitting worsted, had made a sign she would have known that she had not been insulted. Or was there any sense in that?")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Was it really true that if a male and female of the same species were alone in a room together and the male didn’t … then it was an insult? That was an idea that did not exist in a girl’s head without someone to put it there, but once it had been put there it became a luminous veracity! It had been put into her, Valentine Wannop’s head, naturally by Edith Ethel, who equally naturally said that she did not believe it, but that it was a tenet of … oh, the man’s wife! Of the idle, surpassing-the-Lily-and-Solomon-too, surprisingly svelte, tall, clean-run creature who for ever on the shiny paper of illustrated journals advanced towards you with improbable strides along the railings of the Row, laughing, in company with the Honourable Somebody, second son of Lord Some-one-or-other…. Edith Ethel was more refined. She had a title, whereas the other hadn’t, but she was pensive. She showed you that she had read Walter Savage Landor, and had only very lately given up wearing opaque amber beads, as affected by the later pre-Raphaelites. She was practically never in the illustrated papers, but she held more refined views. She held that there were some men who were not like that—and those, all of them, were the men to whom Edith Ethel accorded the ")]), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("entrée")]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }, [_vm._v(" to her Afternoons. She was their Egeria! A refining influence!")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("The Husband of the Wife then? Once he had been allowed in Edith Ethel’s drawing-room: now he wasn’t! … Must have deteriorated!")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("She said to herself sharply, in her “No nonsense, there” mood:")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Chuck it. You’re in love with a married man who’s a Society wife and you’re upset because the Titled Lady has put into your head the idea that you might ‘come together again.’ After ten years!”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("But immediately she protested:")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“No. NO. No! It isn’t that. It’s all right the habit of putting things incisively, but it’s misleading to put things too crudely.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("What was the coming together that was offered her? Nothing, on the face of it, but being dragged again into that man’s intolerable worries as unfortunate machinists are dragged into wheels by belts—and all the flesh torn off their bones! Upon her word that had been her first thought. She was afraid, afraid, afraid! She suddenly appreciated the advantages of nunlike seclusion. Besides she wanted to be bashing policemen with bladders in celebration of Eleven Eleven!")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("That fellow—he had no furniture; he did not appear to recognise the hall porter…. Dotty. Dotty and too morally deteriorated to be admitted to drawing-room of titled lady, the frequenters of which could be trusted not to make love to you on insufficient provocation, if left alone with you….")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Her generous mind reacted painfully.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Oh, that’s not ")]), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("fair")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("!” she said.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("There were all sorts of sides to the unfairness. Before this War, and, of course, before he had lent all his money to Vincent Macmaster that—that grey, grizzly had been perfectly fit for the country-parsonage drawing-room of Edith Ethel Duchemin: he had been welcomed there with effusion! … After the War and when his money was—presumably exhausted, and his mind exhausted, for he had no furniture and did not know the porter…. After the War, then, and when his money was exhausted he was not fit for the Salon of Lady Macmaster—the only Lady to have a Salon in London.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("It was what you called kicking down your ladder!")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Obviously it had to be done. There were such a lot of these bothering War heroes that if you let them all into your Salon it would cease to be a Salon, particularly if you were under obligations to them! … That was already a pressing national problem: it was going to become an overwhelming one now—in twenty minutes time; after those maroons. The impoverished War Heroes would all be coming back. Innumerable. You would have to tell your parlourmaid that you weren’t at home to … about seven million!")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("But wait a minute…. Where did they just stand?")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("He…. But she could not go on calling him just HE like a school-girl of eighteen, thinking of her favourite actor … in the purity of her young thoughts. What was she to call him? She had never—even when they had known each other—called him anything other than Mr. So and So…. She could not bring herself to let her mental lips frame his name…. She had never used anything but his surname to this grey thing, familiar object of her mother’s study, seen frequently at tea-parties…. Once she had been out with it for a whole night in a dog cart! Think of that! … And they had spouted Tibullus one to another in moon-lit mist. And she had certainly wanted it to kiss her—in the moon-lit mists a practically, a really completely strange bear!")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("It couldn’t be done, of course, but she remembered still how she had shivered…. Ph … Ph … Ph…. Shivering.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("She shivered.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Afterwards they had been run into by the car of General Lord Edward Campion, V.C., P.G. Heaven knows what! Godfather of the man’s Society Wife, then taking the waters in Germany…. Or perhaps not ")]), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("her")]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }, [_vm._v(" Godfather. The man")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("’s rather; but her especial champion, in shining armour. In these days they had worn broad red stripes down the outsides of their trousers, Generals. What a change! ")]), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("How")]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }, [_vm._v(" significant of the times!")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("That had been in 1912…. Say the first of July; she could not remember exactly. Summer weather, anyhow, before haymaking or just about. The grass had been long in Hoggs’s Forty Acre, when they had walked through it, discussing Woman’s Suffrage. She had brushed the seed-tops of the heavy grass with her hands as they walked…. Say the 1/7/12.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Now it was Eleven Eleven…. What? Oh, Eighteen, of course!")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Six years ago! What changes in the world! What cataclysms! What Revolutions! … She heard all the newspapers, all the halfpenny paper journalists in creation crying in chorus!")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("But hang it: it was true! If, six years ago she had kissed the … the greyish lacuna of her mind then sitting beside her on the dog-cart seat it would have been the larkish freak of a school-girl: if she did it to-day—as per invitation presumably of Lady Macmaster, bringing them together, for, of course, it could not be performed from a distance or without correspondence—No, communication! … If, then, she did it to-day … to-day … to-day—the Eleven Eleven!—Oh, what a day to-day would be…. Not her sentiments those; quotation from Christina, sister of Lady Macmaster’s favourite poet…. Or, perhaps, since she had had a title she would have found poets more … more chic! The poet who was killed at Gallipoli … Gerald Osborne, was it? Couldn’t remember the name!")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("But for six years then she had been a member of that … triangle. You couldn’t call it a ")]), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("ménage à trois")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v(", even if you didn’t know French. They hadn’t lived together! … They had d—d near died together when the general’s car hit their dog-cart! D—d near! (You ")]), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("must")]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }, [_vm._v(" not use those War-time idioms. ")]), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Do")]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }, [_vm._v(" break yourself of it! Remember the maroons!)")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("An oafish thing to do! To take a school-girl, just … oh, just past the age of consent, out all night in a dog-cart and then get yourself run into by the car of the V.C., P.G., champion-in-red-trouser-stripe of your Legitimate! You’d think any man who ")]), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("was")]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }, [_vm._v(" a man would have avoided that!")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Most men knew enough to know that the Woman Pays … the school-girl too!")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("But they get it both ways…. Look here: when Edith Ethel Duchemin, then, just—or perhaps not quite, Lady Macmaster! At any rate, her husband was dead and she had just married that miserable little…. (Mustn’t use that word!) She, Valentine Wannop, had been the only witness of the marriage—as of the previous, discreet, but so praiseworthy adultery! … When, then, Edith Ethel had…. It must have been on the very day of the knighthood, because Edith Ethel made it an excuse not to ask her to the resultant Party…. Edith Ethel had accused her of having had a baby by … oh, Mr. So and So…. And heaven was her, Valentine Wannop’s, witness that, although Mr. So and So was her mother’s constant adviser, she, Valentine Wannop, was still in such a state of acquaintance with him that she still called him by his surname…. When Lady Macmaster, spitting like the South American beast of burden called a lama, had accused her of having had a baby by her mother’s adviser—to her natural astonishment, but, of course, it had been the result of the dog-cart and the motor and the General, and the general’s sister, Lady Pauline Something—or perhaps it was Claudine? Yes, Lady Claudine!—who had been in the car and the Society Wife, who was always striding along the railings of the Row…. When she had been so accused out of the blue, her first thought—and, confound it, her enduring thought!—had not been concern for her own reputation but for ")]), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("his")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("….")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("That was the ")]), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("quality")]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }, [_vm._v(" of his entanglements, their very essence. He got into appalling messes, unending and unravellable—no, she meant ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("ununravellable!—messes and other people suffered for him whilst he mooned on—into more messes! The General charging the dog-cart was symbolical of him. He was perfectly on his right side and all, but it was like him to be in a dog-cart when flagitious automobiles carrying Generals were running a-muck! Then … the Woman Paid! … She really did, in this case. It had been her mother’s horse they had been driving and, although they had got damages out of the General, the costs were twice that…. And her, Valentine’s reputation had suffered from being in a dog-cart at dawn, alone with a man…. It made no odds that he had—or was it hadn’t?—”insulted” her in any way all through that—oh, that delicious, delirious night…. She had to be said to have a baby by him, and then she had to be dreadfully worried about ")]), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("his")]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }, [_vm._v(" poor old reputation…. ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Of course it ")]), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("would")]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }, [_vm._v(" have been pretty rotten of him—she so young and innocent, daughter of so preposterously emi")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("nent, if so impoverished a man, his father’s best friend and all. “He hadn’t oughter’er done it!” He hadn’t really oughter…. She heard them all saying it, still!")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Well, he hadn’t! … But she?")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("That magic night. It was just before dawn, the mists nearly up to their necks as they drove; the sky going pale in a sort of twilight. And one immense star! She remembered only one immense star, though, historically, there had been also a dilapidated sort of moon. But the star was ")]), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("her")]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }, [_vm._v(" best boy—what her wagon was hitched on to…. And they had been quoting—quarrelling over, she remembered:")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Blockquote--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Flebis et arsuro me, Delia, lecto"), _c('br'), _vm._v("Tristibus et….”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("She exclaimed suddenly:")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Blockquote--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Twilight and evening star"), _c('br'), _vm._v("  And one clear call for me"), _c('br'), _vm._v("And may there be no moaning at the bar"), _c('br'), _vm._v("  When I….”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("She said:")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Oh, but you ")]), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("oughtn’t")]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }, [_vm._v(" to, my dear! That")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("’s ")]), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Tennyson")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("!” Tennyson, with a difference!")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("She said:")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“All the same, that would have been an inexperienced school-girl’s prank…. But if I let him kiss me now I should be….” She would be a what was it … a fornicatress? … ")]), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("trix!")]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }, [_vm._v(" Fornicatrix is preferable! Very preferable. Then why not adultrix? You couldn")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("’t: you had to be a “cold-blooded adultress!” or morality was not avenged.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Oh; but surely not cold-blooded! … Deliberate, then! … That wasn’t, either, the word for the process. Of osculation! … Comic things, words, as applied to states of feelings!")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("But if she went now to Lincoln’s Inn and the Problem held out its arms…. That would be “Deliberate.” It would be asking for it in the fullest sense of the term.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("She said to herself quickly:")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“This way madness lies!” And then:")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“What an imbecile thing to say!”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("She had had an Affair with a man, she made her mind say to her, two years ago. That was all right. There could not be a, say, a schoolmistress rising twenty-four or twenty-five, in the world who hadn’t had ")]), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("some")]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }, [_vm._v(" affair, even if it were no more than a gentleman in a tea-shop who every afternoon for a week had gazed at her disrespectfully over a slice of plumcake…. And then disappeared…. But you had to have had at least a might-have-been or you couldn")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("’t go on being a schoolmistress or a girl in a ministry or a dactylographer of respectability. You packed ")]), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("that")]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }, [_vm._v(" away in the bottom of your mind and on Sunday mornings before the perfectly insufficient Sunday dinner, you took it out and built castles in Spain in which you were a castanetted heroine turning on wonderful hips, but casting behind you inflaming glances…. Something like that!")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Well, she had had an affair with this honest, simple creature! So good! So unspeakably GOOD…. Like the late Albert, prince consort! The very, helpless, immobile sort of creature that she ought not to have tempted. It had been like shooting tame pigeons! Because he had had a Society wife always in the illustrated papers whilst he sat at home and evolved Statistics or came to tea with her dear, tremendous, distracted mother, whom he helped to get her articles accurate. So a woman tempted him and he did…. No; he didn’t quite eat!")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("But why? … Because he was GOOD?")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Very likely!")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Or was it—That was the intolerable thought that she shut up within her along with the material for castles in the air!—was it because he had been really indifferent?")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("They had revolved round each other at tea-parties—or rather he had revolved around her, because at Edith Ethel’s affairs she always sat, a fixed starlet, behind the tea-urn and dispensed cups. But he would moon round the room, looking at the backs of books; occasionally laying down the law to some guest; and always drifting in the end to her side where he would say a trifle or two…. And the beautiful—the quite excruciatingly beautiful wife—striding along the Row with the second son of the Earl of someone at her side…. Asking for it….")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("So it had been from the 1/7/12, say to the 4/8/14!")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("After that, things had become more rubbled—mixed up with alarums. Excursions on his part to unapproved places. And trouble. He was quite damnably in trouble. With his Superiors; with, so unnecessarily, Hun projectiles, wire, mud; over Money; politics; mooning on without a good word from anyone…. Unravellable muddles that never got unravelled but that somehow got you caught up in them….")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Because he needed her moral support! When, during the late Hostilities, he hadn’t been out there, he had drifted to the tea-table much earlier of an afternoon and stayed beside it much longer: till after everyone else had gone and they could go and sit on the tall fender side by side, and argue … about the rights and wrongs of the War!")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Because she was the only soul in the world with whom he could talk…. They had the same sort of good, bread-and-butter brains; without much of the romantic…. No doubt a touch … in him. Otherwise he would not have always been in these muddles. He gave all he possessed to anyone who asked for it. That was all right. But that those who sponged on him should also involve him in intolerable messes…. That was not proper. One ought to defend oneself against that!")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Because … if you do not defend yourself against that, look how you let in your nearest and dearest—those who have to sympathise with you in your confounded troubles whilst you moon on, giving away more and more and getting into more troubles! In this case it was she who was his Nearest and Dearest…. Or had been!")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("At that her nerves suddenly got the better of her and her mind went mad…. Supposing that that fellow, from whom she had not heard for two years, ")]), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("hadn’t")]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }, [_vm._v(" now communicated with her…. Like an ass she had taken it for granted that he had ")]), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("asked")]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }, [_vm._v(" Lady … Blast her! … to ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“bring them together again”! She had imagined that even Edith Ethel would not have had the cheek to ring her up if he hadn’t asked her to!")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("But she had nothing to go on…. Feeble, over-sexed ass that she was, she had let her mind jump at once to the conclusion, the moment the mere mention of him seemed implied—jump to the conclusion that he was asking her again to come and be his mistress…. Or nurse him through his present muddle till he should be fit to….")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Mind, she did not say that she would have succumbed. But if she had not jumped at the idea that it was he, really, speaking through Edith Ethel, she would never have permitted her mind to dwell on … on his blasted, complacent perfections!")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Because she had taken it for granted that if he had had her rung up he would not have been monkeying with other girls during the two years he hadn’t written to her…. Ah, but hadn’t he?")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Look here! ")]), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Was")]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }, [_vm._v(" it reasonable? Here was a fellow who had all but … all BUT … ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“taken advantage of her” one night just before going out to France, say, two years ago…. And not another word from him after that! … It was all very well to say that he was portentous, looming, luminous, loony: John Peel with his coat so grey, the English Country Gentleman ")]), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("pur sang")]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }, [_vm._v(" and then some; saintly; Godlike, Jesus-Christ-like…. He was all that. But you don")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("’t seduce, as near as can be, a young woman and then go off to Hell, leaving her, God knows, in Hell, and not so much as send her, in two years, a picture-postcard with MIZPAH on it. You don’t. You don’t!")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Or if you do you have to have your character revised. You have to have it taken for granted that you were only monkeying with her and that you’ve been monkeying ever since with WAACS in Rouen or some other Base….")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Of course, if you ring your young woman up when you come back … or have her rung up by a titled lady…. That might restore you in the eyes of the world, or at least in the eyes of the young woman if she was a bit of a softie….")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("But ")]), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("had")]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }, [_vm._v(" he? ")]), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Had")]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }, [_vm._v(" he? It was absurd to think that Edith Ethel hadn")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("’t had the face to do it unasked! To save three thousand two hundred pounds, not to mention interest—which was what Vincent owed ")]), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("him")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("!—Edith Ethel with the sweetest possible smile would beg the pillows off a whole hospital ward full of dying…. She was quite right. She had to save her man. You go to any depths of ignominy to save your man.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("But that did not help her, Valentine Wannop!")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("She sprang off the bench; she clenched her nails into her palms; she stamped her thin-soled shoes into the coke-brise floor that was singularly unresilient. She exclaimed:")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Damn it all, he didn’t ask her to ring me up. He didn’t ask her to. He didn’t ask her to!” still stamping about.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("She marched straight at the telephone that was by now uttering long, tinny, night-jar’s calls and, with one snap, pulled the receiver right off the twisted, green-blue cord…. Broke it! With incidental satisfaction.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Then she said:")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Steady the Buffs!” not out of repentance for having damaged School Property, but because she was accustomed to call her thoughts The Buffs because of their practical, unromantic character as a rule…. A fine regiment, the Buffs!")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Of course, if she had not broken the telephone she could have rung up Edith Ethel and have asked her whether he had or hadn’t asked to … to be brought together again…. It was like her, Valentine Wannop, to smash the only means of resolving a torturing doubt….")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("It wasn’t, really, in the least like her. ")]), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("She")]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }, [_vm._v(" was practical enough: none of the ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“under the ban of fatality” business about her. She had smashed the telephone because it had been like smashing a connection with Edith Ethel; or because she hated tinny night-jars; or because she had smashed it. For nothing in the world; for nothing, nothing, nothing in the world would she ever ring up Edith Ethel and ask her:")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Did ")]), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("he")]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }, [_vm._v(" put you up to ringing me up?")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("That would be to let Edith Ethel come between their intimacy.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("A subconscious volition was directing her feet towards the great doors at the end of the Hall, varnished, pitch-pine doors of Gothic architecture; economically decorated as if with straps and tin-lids of Brunswick-blacked cast iron.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("She said:")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Of course if it’s his wife who has removed his furniture that would be a reason for his wanting to get into communication. They would have split…. But he does not hold with a man divorcing a woman, and she won’t divorce.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("As she went through the sticky postern—All that woodwork seemed sticky on account of its varnish!—beside the great doors she said:")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Who cares!”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("The great thing was … but she could not formulate what the great thing was. You had to settle the preliminaries.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-773748ee","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Untitled121.vue
// module id = 78
// module chunks = 0